import { FC } from 'react';
import { Row, styled } from '@streem/ui-react';
import { ModelSerialList } from '@streem/sdk-react';
import { CollapsibleContent } from './collapsible_content';
import { useCompanySettingsStore } from '../../../hooks/use_global_context';
import { useModelSerialDetection } from '../../../hooks/use_model_serial_detection';

export const CallDetailModelSerialNumbers: FC = () => {
    const { streemshots, dedupedModelSerial, handleModelSerialClick } = useModelSerialDetection();

    const companySettings = useCompanySettingsStore();
    const editorNotesEnabled = companySettings.editorNotesEnabled;
    if (!editorNotesEnabled) return null;

    return (
        <Section>
            <CollapsibleContent
                title="Model and Serial Numbers"
                id="post-call-model-serial"
                initialExpandedYn
            >
                <CallDetailWrapper>
                    <ModelSerialList
                        modelSerialDetections={dedupedModelSerial}
                        streemshotBaseUrl={`${location.pathname}/artifact`}
                        streemshots={streemshots}
                        hasFootbar={false}
                        onClickHandler={handleModelSerialClick}
                        editorNotesEnabled={editorNotesEnabled}
                    />
                </CallDetailWrapper>
            </CollapsibleContent>
        </Section>
    );
};

const CallDetailWrapper = styled(Row)({
    columnGap: '2rem',
    margin: '1rem',
});

const Section = styled('section')({
    margin: '1.5rem 0 1.5rem 0',
});
